import {getRequest, postRequest} from "../libs/AxiosService.util";

/**
 * Created by charnjeetelectrovese@gmail.com on 4/30/2020.
 */
export async function serviceGetDashboard(params) {
    return await postRequest('dashboard', params);
}

export async function serviceGetDashboardTables(params) {
    return await postRequest('dashboard/tables', params);
}


export async function serviceGetRecentNoshos() {
    return await getRequest('recent/noshos');
}
